module.exports = __webpack_public_path__ + "static/app_promo-no-bg-c0dfc82e25854770eebb3bf2e1f8f5cb.png";